import { z } from 'zod'

/** Mirrors the Prisma `AuditEventType` enum. */
export const AUDIT_EVENT_TYPES = [
  'ENVELOPE_CREATED',
  'ENVELOPE_SENT',
  'ENVELOPE_COMPLETED',
  'ENVELOPE_DECLINED',
  'ENVELOPE_VOIDED',
  'ENVELOPE_EXPIRED',
  'ENVELOPE_EXTENDED',
  'ENVELOPE_DELETED',
  'DOCUMENT_ADDED',
  'SIGNER_NOTIFIED',
  'SIGNER_VIEWED',
  'SIGNER_SIGNED',
  'SIGNER_DECLINED',
  'SIGNER_REMINDED',
  'SIGNER_LINK_ISSUED',
  'CONSENT_ACCEPTED',
  'STAFF_VIEWED',
  'STAFF_RESENT',
  'STAFF_VOIDED',
  'ARTIFACT_DOWNLOADED',
  'ARTIFACT_LINK_ISSUED',
  'QUESTION_ASKED',
  'QUESTION_REPLIED',
  'ANSWERER_VIEWED',
  'ANSWERER_CONSENT_ACCEPTED',
  'PAPER_COPY_REQUESTED',
] as const

export const auditEventTypeSchema = z.enum(AUDIT_EVENT_TYPES)

export type AuditEventType = z.infer<typeof auditEventTypeSchema>
